export const queryFieldsPrevNext = [
  'title',
  'slug',
]
